import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-cree-cmd-negoce',
  templateUrl: './cree-cmd-negoce.component.html',
  styleUrls: ['./cree-cmd-negoce.component.scss']
})
export class CreeCmdNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        console.log('CreeCmdNegoceComponent initialized');
        this.dataService.filterOrdersByStatus('Créé');
    }

}
